module.exports = __webpack_public_path__ + "img/3.198319c9.jpg";